module.exports = __webpack_public_path__ + "img/game_item_img2.1ed7b638.png";